module.exports = __webpack_public_path__ + "web_static/img/spacespcMoblieBg01.49466714.png";